import React from "react";
import { motion } from "framer-motion";
import { CalendarIcon, UserCheckIcon, ClockIcon, TrendingUpIcon, GraduationCapIcon, BoxIcon } from "lucide-react";
interface Pain {
  icon: BoxIcon;
  title: string;
  text: string;
}
const PAINS: Pain[] = [{
  icon: CalendarIcon,
  title: 'Sentís que improvisás tus clases',
  text: 'Llegás al estudio pensando qué ejercicios hacer, repetís secuencias o cambiás el plan sobre la marcha porque no tenés una estructura clara.'
}, {
  icon: UserCheckIcon,
  title: 'Te preocupa no saber adaptar un ejercicio',
  text: 'Cuando aparece una embarazada, un alumno con dolor lumbar o alguien con una limitación, dudás sobre qué hacer y terminás improvisando.'
}, {
  icon: ClockIcon,
  title: 'Pasás más tiempo preparando las clases que enseñando',
  text: 'Horas buscando ejercicios en Instagram, YouTube o anotaciones viejas para terminar armando una sola clase.'
}, {
  icon: TrendingUpIcon,
  title: 'Hacé crecer tu carrera como profesor',
  text: 'Aprendé a atraer más alumnos, posicionarte como referente y aumentar el valor de tus clases con herramientas de marketing pensadas para profesionales del pilates.'
}, {
  icon: GraduationCapIcon,
  title: 'Convertite en un profesional más completo',
  text: 'Dominá Pilates Mat, Reformer, Gravity y Wunda Chair con especializaciones diseñadas para ampliar tus habilidades y destacarte frente a la competencia.'
}];
export function PainPoints() {
  return <section className="w-full bg-beige py-16 sm:py-20 pt-[1px] pb-[1px]" data-id="element-128" data-mp="1g2cess88nved">
      <div className="mx-auto max-w-6xl px-6" data-id="element-129" data-mp="1b3rfcv0t9fqz">
        <div className="mx-auto max-w-2xl text-center" data-id="element-130" data-mp="1b52lh1hqazl9">
          
          <h2 className="mt-5 font-serif text-4xl font-semibold leading-[1.05] text-brown-dark sm:text-5xl" data-id="element-131" data-mp="1p428y5ti98fu">
            ¿Te pasa alguna de estas situaciones?
          </h2>
          <p className="mx-auto mt-4 max-w-xl text-base leading-relaxed text-brown-dark/70 sm:text-lg" data-id="element-132" data-mp="30guugyvpd0ng">
            Si preparar cada clase te genera dudas, este sistema te devuelve estructura y seguridad.
          </p>
        </div>

        <div className="mt-10 grid gap-5 sm:grid-cols-2 lg:grid-cols-3" data-id="element-133" data-mp="1t4vkcjzvwoq9">
          {PAINS.map(({
          icon: Icon,
          title,
          text
        }, i) => <motion.article key={title} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-60px'
        }} transition={{
          duration: 0.5,
          delay: i % 3 * 0.08
        }} className="rounded-2xl border border-brown-light/15 bg-white p-7 shadow-sm" data-id="element-134" data-mp="225bm9p0zbnt0" data-mpi={i}>
              <div className="mb-5 inline-flex h-12 w-12 items-center justify-center rounded-xl bg-beige-deep text-brown-light" data-id="element-135" data-mp="1edwdpeim0a9b">
                <Icon className="h-6 w-6" strokeWidth={1.75} data-id="element-136" data-mp="1o6lp69e5to4n" />
              </div>
              <h3 className="font-serif text-xl font-semibold leading-snug text-brown-dark" data-id="element-137" data-mp="qqo8sxp3f37t">
                {title}
              </h3>
              <p className="mt-3 text-sm leading-relaxed text-brown-dark/70" data-id="element-138" data-mp="vopt1ly998kv">
                {text}
              </p>
            </motion.article>)}
        </div>
      </div>
    </section>;
}